import {
    Badge,
    Box,
    Button,
    Group,
    Image,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';

import { NavLink } from 'react-router-dom';

const MediaContentCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const src = `https://${rowData.s3Storage?.s3Bucket}/${rowData.s3Storage?.s3Fullsize}`;
    const srcThumbnail = `https://${rowData.s3Storage?.s3Bucket}/${rowData.s3Storage?.s3Thumbnail}`;
    return (
        <NavLink
            to={src}
            target={'_blank'}>
            <Tooltip label={<Image src={srcThumbnail} />}>
                <Button size={'compact-xs'}>View</Button>
            </Tooltip>
        </NavLink>
    );
};

const MediaContentColumn = () => ({
    accessorKey: 'name',
    header: 'Media Content',
    size: 2,
    minSize: 300,
    Cell: ({ cell }) => <MediaContentCell cell={cell} />,
});
export default MediaContentColumn;
